'use client';

import React, { type FC } from 'react';
import { formatCreditsNumber } from '../utils/formatters';
import { IoTicket } from './icons';

interface BandTicketsProps {
  amount: number;
  className?: string;
  showIcon?: boolean;
  iconSize?: number;
  iconOnly?: boolean; // Show only icon without amount
  muted?: boolean; // Dim variant, e.g. for an already-claimed reward
}

/** SHOT BAND raffle-ticket counter — Credits' sibling, blue ticket icon instead of the coin. */
export const BandTickets: FC<BandTicketsProps> = ({ amount, className, showIcon = true, iconSize = 12, iconOnly = false, muted = false }) => {
  return (
    <span className={`inline-flex items-center gap-1 ${className || ''}`}>
      {!iconOnly && formatCreditsNumber(amount)}
      {showIcon && <IoTicket className={muted ? 'text-blue-400/50 shrink-0' : 'text-blue-400 shrink-0'} size={iconSize} />}
    </span>
  );
};
